export const EVENT_CATEGORY = {
  MEDIA_USE: {
    NAME: 'MEDIA_USE',
    ACTION: {
      PUBLISH: 'PUBLISH',
      UPLOAD: 'UPLOAD',
      SELECT: 'SELECT',
    },
  },
  CREATIVE_UPDATE: {
    NAME: 'CREATIVE_UPDATE',
    ACTION: {
      APPEND_CLIP: 'APPEND_CLIP',
      CHANGE_DURATION: 'CHANGE_DURATION',
      CREATE_CLIP_FROM_SHOTS: 'CREATE_CLIP_FROM_SHOTS',
      SET_BLEND_MODE: 'SET_BLEND_MODE',
    },
  },
  TIMING: {
    NAME: 'TIMING',
    ACTION: {
      PAGE_LOAD_END: 'PAGE_LOAD_END',
    },
  },
  UI: {
    NAME: 'UI',
    ACTION: {
      CHANGE_CHAPTER_BREAKS: 'CHANGE_CHAPTER_BREAKS',
      CLIPBOARD_COPY: 'CLIPBOARD_COPY',
      CLIPBOARD_CUT: 'CLIPBOARD_CUT',
      CLIPBOARD_PASTE: 'CLIPBOARD_PASTE',
      COPY_SELECTED_ELEMENT: 'COPY_SELECTED_ELEMENT',
      DOWNLOAD_CURRENT_FRAME: 'DOWNLOAD_CURRENT_FRAME',
      EPISODE_PAN_SHOT: 'EPISODE_PAN_SHOT',
      EPISODE_TIMELINE: 'EPISODE_TIMELINE',
      LEFT_PANEL: 'LEFT_PANEL',
      LOCKED_LAYER: 'LOCKED_LAYER',
      OPEN_KEBAB_MENU: 'OPEN_KEBAB_MENU',
      PROJECT_WORKFLOW: 'PROJECT_WORKFLOW',
      REVIEW: 'REVIEW',
      SHOT_LAYOUT_PROPERTIES: 'SHOT_LAYOUT_PROPERTIES',
      SHOT_SELECTION: 'SHOT_SELECTION',
      SKIP_SHOTS: 'SKIP_SHOTS',
      SWITCH_TO_ADVANCED_FROM_SIMPLE: 'SWITCH_TO_ADVANCED_FROM_SIMPLE',
      UPDATE_CREATIVE_DIMENSIONS: 'UPDATE_CREATIVE_DIMENSIONS',
    },
    EVENT_LABEL: {
      CHANGE_CHAPTER_BREAKS: {
        ADD: 'ADD',
        INIT: 'INIT',
        DELETE: 'DELETE',
        MOVE: 'MOVE',
        RESET: 'RESET',
      },
      EPISODE_PAN_SHOT: {
        DRAG_KEYFRAME: 'DRAG_KEYFRAME',
      },
      EPISODE_TIMELINE: {
        TOGGLE_ZOOM: 'TOGGLE_ZOOM',
      },
      LEFT_PANEL: {
        TAB_SELECTION: 'TAB_SELECTION',
      },
      LOCKED_LAYER: {
        TOGGLED_LOCKED_OFF: 'TOGGLED_LOCKED_OFF',
        TOGGLED_LOCKED_ON: 'TOGGLED_LOCKED_ON',
      },
      OPEN_KEBAB_MENU: {
        CLICK_EC_RELEASE_NOTES: 'KEBAB_EC_RELEASE_NOTES',
      },
      PROJECT_WORKFLOW: {
        CONVERT_PROJECT_BUTTON_CLICKED: 'CONVERT_PROJECT_BUTTON_CLICKED',
        CUSTOMIZE_PROJECT_BUTTON_CLICKED: 'CUSTOMIZE_PROJECT_BUTTON_CLICKED',
        DESIGN_PROJECT_BUTTON_CLICKED: 'DESIGN_PROJECT_BUTTON_CLICKED',
      },
      REVIEW: {
        ADD_TO_DRAFT_CLICKED: 'ADD_TO_DRAFT_CLICKED',
        DOWNLOAD_SNAPS_CLICKED: 'DOWNLOAD_SNAPS_CLICKED',
        DOWNLOAD_VIDEO_CLICKED: 'DOWNLOAD_VIDEO_CLICKED',
        OPEN_TO_ADS_MANAGER_CLICKED: 'OPEN_TO_ADS_MANAGER_CLICKED',
        PUBLISH_CLICKED: 'PUBLISH_CLICKED',
        PUBLISH_TO_ADS_MANAGER_CLICKED: 'PUBLISH_TO_ADS_MANAGER_CLICKED',
        REVIEW_MODAL_CLOSED: 'REVIEW_MODAL_CLOSED',
        REVIEW_MODAL_OPENED: 'REVIEW_MODAL_OPENED',
      },
      SHOT_LAYOUT_PROPERTIES: {
        COPY: 'COPY',
        PASTE: 'PASTE',
      },
      SHOT_SELECTION: {
        DRAG_HANDLE: 'MULTISHOT_SELECT_DRAG_HANDLE',
        META_CLICK: 'MULTISHOT_SELECT_META_CLICK',
        SELECT_ALL: 'SELECT_ALL',
        SHIFT_ARROW: 'MULTISHOT_SELECT_SHIFT_ARROW',
        SHIFT_CLICK: 'MULTISHOT_SELECT_SHIFT_CLICK',
      },
      SKIP_SHOTS: {
        TOGGLED_SHOTS_OFF: 'TOGGLED_SHOTS_OFF',
        TOGGLED_SHOTS_ON: 'TOGGLED_SHOTS_ON',
      },
    },
  },
};
